import React, { Component } from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Typography from '../UI/Typography'
import { device } from '../../utils/helpers'

import Map from '../UI/GoogleMap'
import LocationIcon from '../UI/Icons/LocationIcon'
import PhoneIcon from '../UI/Icons/PhoneIcon'
import EmailIcon from '../UI/Icons/EmailIcon'
import ContactForm from '../Forms/Contact'

const Wrapper = styled.div`
  margin-top: 80px;

  @media ${device.tablet} {
    margin-top: 120px;
  }
`

const Section = styled.section`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 5rem 2rem;

  @media ${device.tablet} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas:
      'info details'
      'form form';
  }

  @media ${device.laptopM} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas:
      'info details form';
    align-items: initial;
    padding: 5rem;
  }

  @media ${device.laptopL} {
    padding: 5rem 8rem 10rem 8rem;
  }
`

const Info = styled.div`
  text-align: left;
  grid-area: info;
`

const Details = styled.div`
  width: 100%;
  padding: 1.5rem 0;
  grid-area: details;

  @media ${device.tablet} {
    padding-left: 15%;
  }

  @media ${device.laptopM} {
    padding-top: 0;
  }
`

const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 1.25rem 0;
`

const ItemText = styled.div`
  font-family: 'BarlowSemiBold';
  font-size: 18px;
  text-align: left;
  padding-left: 2rem;

  @media ${device.desktop} {
    font-size: 28px;
  }
`

const ContactItem = ({ icon, children }) => (
  <ItemWrapper>
    {icon}
    <ItemText>
      {children}
    </ItemText>
  </ItemWrapper>
)

const StlyedLocationIcon = styled(LocationIcon)`
  width: ${props => props.mobileWidth};

  @media ${device.desktop} {
    width: ${props => props.width};
  }
`

const StlyedPhoneIcon = styled(PhoneIcon)`
  width: ${props => props.mobileWidth};

  @media ${device.desktop} {
    width: ${props => props.width};
  }
`

const StlyedEmailIcon = styled(EmailIcon)`
  width: ${props => props.mobileWidth};

  @media ${device.desktop} {
    width: ${props => props.width};
  }
`

const FormWrapper = styled.div`
  text-align: left;
  width: 100%;
  padding: 1.5rem 0;
  grid-area: form;

  @media ${device.laptopM} {
    padding-top: 0;
  }
`

class Contact extends Component {
  render () {
    return (
      <Wrapper>
        <Helmet>
          <title>Noleggio Campi Calcetto Basket e Beach Volley</title>
          <meta name='Description' content='Contattaci per avere informazioni sulle nostre strutture o per avere supporto nell organizzazione del tuo evento!' />
          <meta name='Keywords' content='campi smontabili,noleggio attrezzature sportive,noleggio impianti sportivi mobili' />
          <meta name='robots' content='noindex, nofollow' />
        </Helmet>
        <Map
          url='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2797.4796086514525!2d9.2047034!3d45.4802859!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786c6c6cb646633%3A0x76eb615b51bf2ffb!2sVia+Benedetto+Marcello%2C+1%2C+20124+Milano+MI%2C+Italy!5e0!3m2!1sen!2sin!4v1531292545599'
          width='100%'
          height='600px'
        />
        <Section>
          <Info>
            <Typography padding='1.2rem 0' variant='h2' type='title'>CONTATTACI</Typography>
            <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
              Vuoi organizzare un evento? Hai bisogno di noleggiare le strutture per il tuo torneo? Vuoi semplicemente chiedere informazioni o chiedere un appuntamento?
            </Typography>
            <Typography padding='1.2rem 0' minSize='16px' maxSize='21px'>
              Contattaci subito per entrare in contatto con la nostra realtà. Siamo pronti a rispondere a tutte le tue domande!
            </Typography>
          </Info>
          <Details>
            <ContactItem icon={<StlyedLocationIcon width='62px' mobileWidth='47px' fill='#fca317' />}>
              <span>Via Benedetto <br /></span>
              <span>Marcello 1, Milano</span>
            </ContactItem>
            <ContactItem icon={<StlyedPhoneIcon width='77px' mobileWidth='58px' fill='#fca317' />}>
              <span>(+39) 02 36518242</span>
            </ContactItem>
            <ContactItem icon={<StlyedEmailIcon width='70px' mobileWidth='53px' fill='#fca317' />}>
              <span>info@noleggiocampi.it</span>
            </ContactItem>
          </Details>
          <FormWrapper>
            <ContactForm />
          </FormWrapper>
        </Section>
      </Wrapper>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/Pages/Contact.js